import { useDroppable } from "@dnd-kit/core";
import { observer } from "mobx-react-lite";
import s from "./DroppableBox.module.scss";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  id: string;
  children: React.ReactNode;
}

export const DroppableBox = observer((props: Props) => {
  const { isOver, setNodeRef } = useDroppable({
    id: props.id,
  });

  const style = {
    opacity: isOver ? 1 : 0.5,
    ...props.style,
  };

  return (
    <div ref={setNodeRef} className={s.dropbox} style={style} {...props}>
      {props.children}
    </div>
  );
});
